<template>
  <FloatingCard :feeling="feeling">
    <ContainersList
      :token="token"
      :roomID="roomID"
      name="import"
      @status-change="updateStatus"
      @container-change="updateSelectedContainer"
    />
  </FloatingCard>
</template>

<script>
import ContainersList from '@/components/ContainersList';
import FloatingCard from '@/components/FloatingCard';

export default {
  name: 'ImportContainerCard',
  components: {
    ContainersList,
    FloatingCard,
  },
  props: {
    token: {
      type: String,
    },
    roomID: {
      type: String,
    },
  },
  data() {
    return {
      status: null,
      selectedContainer: '',
    };
  },
  computed: {
    feeling() {
      switch (this.status) {
        case 'retrieving-recent-containers':
          return 'pending';
        case 'recent-containers-retrieved':
          return null;
        case 'listing-structure':
          return 'pending';
        case 'structure-listed':
          return null;
        case 'something-wrong':
          return 'negative';
        default:
          return null;
      }
    },
  },
  methods: {
    updateStatus(payload) {
      this.status = payload.status;
    },
    updateSelectedContainer(payload) {
      this.selectedContainer = payload;
    },
  },
  watch: {
    status() {
      this.$emit('status-change', { status: this.status, data: this.$data });
      this.selectedContainer = '';
    },
    selectedContainer() {
      if (this.selectedContainer) {
        this.$emit('container-change', this.selectedContainer);
      } else {
        this.$emit('container-change');
      }
    },
  },
  beforeDestroy() {
    this.selectedContainer = '';
  },
};
</script>
